import React from "react";
import { FaCheck } from "react-icons/fa";

export default function PermissionChart() {
  // Create a basic permission chart for the provider
  return (
    <div className="border my-2 mx-auto w-[80%] rounded-md border-primaryBlue grid grid-cols-5 overflow-hidden shadow-md">
      <div className="text-center bg-gray-100"></div>
      <div className="chart-header">Post Availability</div>
      <div className="chart-header">Edit Listing Information</div>
      <div className="chart-header">Edit Premium Features</div>
      <div className="chart-header">Manage Other Users</div>

      <div className="chart-header">Manager</div>
      <div className="chart-body">
        <FaCheck className="text-primaryBlue" />
      </div>
      <div className="chart-body">
        <FaCheck className="text-primaryBlue" />
      </div>
      <div className="chart-body">
        <FaCheck className="text-primaryBlue" />
      </div>
      <div className="chart-body">
        <FaCheck className="text-primaryBlue" />
      </div>

      <div className="chart-header">Editor</div>
      <div className="chart-body">
        <FaCheck className="text-primaryBlue" />
      </div>
      <div className="chart-body">
        <FaCheck className="text-primaryBlue" />
      </div>
      <div className="chart-body">
        <FaCheck className="text-primaryBlue" />
      </div>
      <div className="chart-body"></div>

      <div className="chart-header">Reporter</div>
      <div className="chart-body">
        <FaCheck className="text-primaryBlue" />
      </div>
      <div className="chart-body"></div>
      <div className="chart-body"></div>
      <div className="chart-body"></div>
    </div>
  );
}
